// src/pages/Services.jsx
import React from 'react';
import Seo from '../components/Seo';
import BreadcrumbJsonLd from '../components/BreadcrumbJsonLd';

import Hero from '../components/Home/Hero';
import ServiceSidebarLayout from '../components/Services/ServiceSidebarLayout';
import WhyOurServices from '../components/Services/WhyOurServices';
import './Services.css';           // óf verwijder als je niets meer nodig hebt

// Lease-pakketten
const servicesData = [
  {
    id: 1,
    slug: 'webdesign',
    title: 'Webdesign Lease',
    subtitle: 'Website & apps – snel en groei­gericht',
    price: 39,
    frequency: 'p/m',
    features: [
      'Basisset-up in jouw branding',
      'Contactformulier + online afspraken',
      'Supersnelle laadtijd (Core Web Vitals)',
      'Maandelijks onderhoud & updates',
    ],
    examples: [
      { client: 'Hair Rock Knipcafé',     result: '+30% online afspraken in 2 mnd' },
      { client: 'Pedicure VoetenVrolijk', result: '+25% boekingen via nieuwe site' },
    ],
    ctaLabel: 'Vrijblijvende offerte',
    ctaHref: '/contact',
  },
  {
    id: 2,
    slug: 'social-media',
    title: 'Social Media Beheer Lease',
    subtitle: 'Altijd zichtbaar met relevante posts',
    price: 49,
    frequency: 'p/m',
    features: [
      'Maandelijkse content­kalender',
      'Professionele visuals (foto & video)',
      'Reacties en DM’s beheerd',
      'Resultaatrapport (reach & engagement)',
    ],
    examples: [
      { client: 'Hair Rock Knipcafé',           result: '+20% volgers & 15% meer afspraken via Instagram' },
      { client: 'Aannemersbedrijf BouwWonders', result: '10+ aanvragen via Facebook in 1 maand' },
    ],
    ctaLabel: 'Gratis strategie-call',
    ctaHref: '/contact',
  },
  {
    id: 3,
    slug: 'seo',
    title: 'SEO Lease',
    subtitle: 'Meer vindbaarheid, meer klanten',
    price: 99,
    frequency: 'p/m',
    features: [
      'Technische audit & snelheid',
      'Zoekwoorden op jouw branche',
      'Optimalisatie teksten & meta-data',
      'Maandelijkse rankings & bezoekersrapport',
    ],
    examples: [
      { client: 'Pedicure VoetenVrolijk', result: '+50% organisch verkeer in 3 mnd' },
      { client: 'BouwSterk Aannemers',    result: 'Topposities & +15 leads per maand' },
    ],
    ctaLabel: 'Gratis SEO-scan',
    ctaHref: '/seo-scan',
  },
  {
    id: 4,
    slug: 'sea',
    title: 'SEA / Ads Lease',
    subtitle: 'Direct resultaat met betaalde advertenties',
    price: 199,
    frequency: 'p/m',
    features: [
      'Keyword- of doelgroep­onderzoek',
      'Opzetten & optimaliseren campagnes',
      'Landings­pagina-analyse',
      'Maandelijkse rapportage & advies',
    ],
    examples: [
      { client: 'Hair Rock Knipcafé',     result: '3× ROI via Facebook Ads in 2 mnd' },
      { client: 'Pedicure VoetenVrolijk', result: 'Volledige bezetting via Google Ads' },
    ],
    ctaLabel: 'Voorstel op maat',
    ctaHref: '/contact',
  },
  {
    id: 5,
    slug: 'branding',
    title: 'Branding Lease',
    subtitle: 'Een herkenbaar merk dat vertrouwen wekt',
    price: 49,
    frequency: 'p/m',
    features: [
      'Logo-ontwerp & kleurenschema',
      'Visitekaartjes & briefpapier',
      'Social-media templates',
      'Mini-stijlgids voor consistentie',
    ],
    examples: [
      { client: 'BouwWonders Aannemers', result: '+20% offerte­aanvragen na rebrand' },
      { client: 'Hair Rock Knipcafé',    result: '+35% shop-traffic dankzij nieuwe stijl' },
    ],
    ctaLabel: 'Plan branding-sessie',
    ctaHref: '/contact',
  },
  {
    id: 6,
    slug: 'flyers',
    title: 'Flyer Lease',
    subtitle: 'Tastbaar bereik in de buurt',
    price: 199,
    frequency: 'p/m',
    features: [
      'Ontwerp in jouw huisstijl',
      'Drukwerk op stevig papier',
      'Gerichte postcode­selectie',
      'Verspreiding binnen 1 week',
    ],
    examples: [
      { client: 'Pedicure VoetenVrolijk', result: '+40% nieuwe klanten in wijk X' },
      { client: 'BouwWonders Aannemers',  result: '+10 offertes via flyer­actie' },
    ],
    ctaLabel: 'Flyer-voorstel',
    ctaHref: '/contact',
  },
];

export default function ServicesPage() {
  return (
    <>
      {/* 1. SEO */}
      <Seo
        title="Diensten | Online Growth Club"
        description="Onze lease-diensten: webdesign, SEO, SEA & social media – alles op abonnements­basis."
        path="/diensten"
      />

      {/* 2. Breadcrumb structured data */}
      <BreadcrumbJsonLd
        list={[
          { name: 'Home',     item: 'https://onlinegrowthclub.nl/' },
          { name: 'Diensten', item: 'https://onlinegrowthclub.nl/diensten' },
        ]}
      />

      {/* 3. Pagina-secties */}
      <Hero
        title="Onze"
        highlight="Diensten"
        subtitle="Alles om online te groeien – op leasebasis"
      />
      <ServiceSidebarLayout services={servicesData} pricePrefix="Vanaf" />
      <WhyOurServices />
    </>
  );
}
